export const getProductListPivotProductPricingRules = productList => {
  const activeProductIds = new Set(
    productList
      .filter(p => p.isMandatory !== false || p.isPreSelected === true)
      .map(p => p.id)
  )
  const initialized = getInitializedProductListRules(productList)
  return productList.reduce(
    (acc, product) => getPivotProductRulesFromProduct(acc, product, activeProductIds),
    initialized,
  )
}

const getInitializedProductListRules = productList => {
  return productList.reduce((acc, curr) => {
    acc[curr.id] = {
      extraPricingRatio: {},
      belowPricingRatio: {},
    }
    return acc
  }, {})
}

const getPivotProductRulesFromProduct = (productListPivotRules, product, activeProductIds) => {
  const activeRules = product.pricingRules.pivotProductRules.filter(rule =>
    activeProductIds.has(rule.pivotProductId)
  )

  const objExtraPricingRatio = activeRules.reduce((acc, item) => {
    acc[item.pivotProductId] = item.extraPricingRatio
    return acc
  }, {})
  productListPivotRules[product.id].extraPricingRatio = objExtraPricingRatio

  for (const rule of activeRules) {
    const { pivotProductId, extraPricingRatio } = rule
    productListPivotRules[pivotProductId].belowPricingRatio[product.id] = extraPricingRatio
  }
  return productListPivotRules
}
